import { useEffect } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useA11yStore } from './store'
import { DEFAULT_PREFS } from './constants'

export function useCSSBridge(): void {
  const prefs = useA11yStore(useShallow((state) => ({
    textSize: state.textSize,
    cursorSize: state.cursorSize,
    contrast: state.contrast,
    motion: state.motion,
    dyslexia: state.dyslexia,
    focus: state.focus,
  })))

  useEffect(() => {
    if (typeof document === 'undefined') return

    const root = document.documentElement

    // Text size
    if (prefs.textSize === DEFAULT_PREFS.textSize) {
      root.removeAttribute('data-a11y-text-size')
    } else {
      root.setAttribute('data-a11y-text-size', prefs.textSize)
    }

    // Cursor size
    if (prefs.cursorSize === DEFAULT_PREFS.cursorSize) {
      root.removeAttribute('data-a11y-cursor')
    } else {
      root.setAttribute('data-a11y-cursor', prefs.cursorSize)
    }

    // Contrast
    if (prefs.contrast === DEFAULT_PREFS.contrast) {
      root.removeAttribute('data-a11y-contrast')
    } else {
      root.setAttribute('data-a11y-contrast', prefs.contrast)
    }

    // Motion
    if (prefs.motion === DEFAULT_PREFS.motion) {
      root.removeAttribute('data-a11y-motion')
    } else {
      root.setAttribute('data-a11y-motion', prefs.motion)
    }

    // Dyslexia
    if (prefs.dyslexia === DEFAULT_PREFS.dyslexia) {
      root.removeAttribute('data-a11y-dyslexia')
    } else {
      root.setAttribute('data-a11y-dyslexia', prefs.dyslexia)
    }

    // Focus
    if (prefs.focus === DEFAULT_PREFS.focus) {
      root.removeAttribute('data-a11y-focus')
    } else {
      root.setAttribute('data-a11y-focus', prefs.focus)
    }
  }, [prefs])
}
